<template>
  <main>
    <section>
      <div class="container">
        <div class="row">
          <div class="col_xl_12 col_l_12 col_m_12 col_s_12">
            <h1 class="tac login_big">Enter your name</h1>
          </div>
        </div>

        <div class="row">
          <div
            class="col_xl_8 xl_offset_2 col_l_8 l_offset_2 col_m_12 col_s_12"
          >
            <inputWrap
              :title="'Your name'"
              :type="'text'"
              :inputData.sync="guestName"
              :errorText="'Bad user name'"
              :hasError="hasError"
              :placeholder="'e.g., Edith Anderson'"
            ></inputWrap>
          </div>

          <div
            class="col_xl_8 xl_offset_2 col_l_8 l_offset_2 col_m_12 col_s_12"
          >
            <div class="df s_betwen login_lover_links_wrap">
              <router-link to="/auth/login" class="login_lover_links hover_op"
                >Already have an account?</router-link
              >
            </div>
          </div>

          <div
            class="col_xl_8 xl_offset_2 col_l_8 l_offset_2 col_m_12 col_s_12"
          >
            <router-link
              to="/dashboard"
              class="color_btn hover_op"
              :class="{ disabeled: guestName == '' }"
              >Next</router-link
            >
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import inputWrap from "@/components/inputWrap.vue";

export default {
  name: "Enter_your_name",
  data() {
    return {
      guestName: "",
      hasError: false,
    };
  },

  components: {
    inputWrap,
  },
};
</script>

<style scoped lang="scss">
section {
  margin-top: 48px;

  @media screen and (min-width: 1280px) {
    margin-top: 112px;
  }
}
</style>
